export default "__VITE_ASSET__DSi6I4QN__"